// `null` when the viewer has zero or several teams — those cases are left for
// the create form's team selector to resolve; only a sole team is auto-selected.
export function resolveCreationTeamId(
  viewerTeams: readonly { id: string }[]
): string | null {
  return viewerTeams.length === 1 ? viewerTeams[0].id : null;
}
